import { render, staticRenderFns } from "./RepairDetail.vue?vue&type=template&id=143ef13e"
import script from "./RepairDetail.vue?vue&type=script&lang=js"
export * from "./RepairDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports